/**
 * Created by Amit Panghal.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TractorBeamGameConfig} from "../TractorBeamGameConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TractorBeamStickySymbol} from "../randomfeature/TractorBeamStickySymbol";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {TimelineLite, TweenLite} from "gsap";
import {TractorBeamGameModuleConfig} from "../TractorBeamGameModuleConfig";
import {TractorBeamHelper} from "../../utils/TractorBeamHelper";

export class TractorBeamCommandCenterView extends BaseView {
    private _commandCenter:PIXI.Container;

    private _commandCenterLandscapeBG:PIXI.Sprite;
    private _commandCenterPortraitSprite:PIXI.Sprite;

    private _commandCenterLayer:ScalableLayer;
    private _gameSymbols:{symName: string, sym: TractorBeamStickySymbol}[] = [];
    private _config:any;
    private _removedSymbols:string[];

    private _landscapePositions:PIXI.Point [] = [
        new PIXI.Point(40, 50),
        new PIXI.Point(100, 50),
        new PIXI.Point(170, 50),
        new PIXI.Point(40, 120),
        new PIXI.Point(100, 120),
        new PIXI.Point(170, 120),
        new PIXI.Point(40, 190),
        new PIXI.Point(100, 190),
        new PIXI.Point(170, 190)
    ];

    private _portraitPositions:PIXI.Point [] = [
        new PIXI.Point(55, 45),
        new PIXI.Point(115, 45),
        new PIXI.Point(185, 45),
        new PIXI.Point(255, 45),
        new PIXI.Point(320, 45),
        new PIXI.Point(105, 100),
        new PIXI.Point(165, 100),
        new PIXI.Point(220, 100),
        new PIXI.Point(275, 100)
    ];

    constructor(resourceGroup:ResourcesGroupName) {
        super();
        this._commandCenterLayer = StageManager.getLayer(TractorBeamGameConfig.instance.LAYERS.COMMAND_CENTER.name);
        this._config = {modulas: 3, index: 0, xdiff: 50, scale: 0.4};
        this._commandCenterLayer.addChild(this);
    }

    protected initAnimations():void{
        const gameSymbols:string[] = ["S", "M1","M2","M3","M4","L1","L2","L3","L4"];

        this._commandCenter = new PIXI.Container();
        this._commandCenter.visible = false;

        // Compose the landscape panel
        const compositePortrait:PIXI.Sprite = new PIXI.Sprite();
        compositePortrait.position.set(300, 200);


        const poPanel:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("justPanel")[0]);
        poPanel.scale.set(0.735, 0.9);
        poPanel.rotation = TractorBeamHelper.radians(-90);
        const poPole:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("pole")[0]);
        poPole.anchor.set(-1.1, 3);
        poPole.position.set(0, 0);
        poPole.scale.set(1.75, 1);

        compositePortrait.addChild(poPole);
        compositePortrait.addChild(poPanel);


        this._commandCenterPortraitSprite = compositePortrait;
        this._commandCenterPortraitSprite.anchor.set(0.5, 0.5);

        // Compose the landscape panel
        const compositeLandscape:PIXI.Sprite = new PIXI.Sprite();
        const panel:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("justPanel")[0]);
        const topPole:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("pole")[0]);
        topPole.anchor.set(-1, 0);
        topPole.position.set(13, 110);
        const bottomPole:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("pole")[0]);
        bottomPole.anchor.set(-1, 0);
        bottomPole.position.set(11, 280);
        compositeLandscape.addChild(topPole);
        compositeLandscape.addChild(bottomPole);
        compositeLandscape.addChild(panel);
        this._commandCenterLandscapeBG = compositeLandscape;


        this._commandCenter.addChild(this._commandCenterLandscapeBG);
        this._commandCenter.addChild(this._commandCenterPortraitSprite);

        for (let i = 0; i < gameSymbols.length; i++){
            this._commandCenter.addChild(this.createCommandCenterSymbol(gameSymbols[i], i));
        }
        this._commandCenter.position.set(1071,150);
        this.addChild(this._commandCenter);
    }

    protected onResize(resizeData: IResizeData): void {
        this._commandCenterPortraitSprite.visible = false;


        this._commandCenterLandscapeBG.visible = true;
        this._commandCenter.position.set(1071,150); // Landscape, appearently

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._commandCenterPortraitSprite.visible = true;
            this._commandCenterPortraitSprite.position.set(0, 150);
            this._commandCenterLandscapeBG.visible = false;
            this._commandCenter.position.set(455, 710);
            this._config.modulas = 5;
            this._config.xdiff = 75;
            this._config.scale = 0.4;
        }
        for(let i=0; i < this._gameSymbols.length; i++){
            this._config.index = i;

            this.setPositionsAsOrientation(this._config, this._gameSymbols[i].sym);

            if(resizeData.orientation === Orientation.LANDSCAPE) {
                this._gameSymbols[i].sym.position.set(this._landscapePositions[i].x, this._landscapePositions[i].y);
            }
            else {
                this._gameSymbols[i].sym.position.set(this._portraitPositions[i].x, this._portraitPositions[i].y);
            }
        }
    }

    private createPotraitBG():PIXI.Graphics{
        let bgPotrait:PIXI.Graphics = new PIXI.Graphics();
        bgPotrait.beginFill(0x000000);
        bgPotrait.drawRoundedRect(0, 0, 390, 130, 10);
        bgPotrait.endFill();
        bgPotrait.visible = false;
        return bgPotrait;
    }

    private createCommandCenterSymbol(symName:string, index:number):TractorBeamStickySymbol{
        let commandCenterSymbol:TractorBeamStickySymbol = new TractorBeamStickySymbol(symName, true);
        //this.setPositionsAsOrientation({modulas: 3, index: index, xdiff: 50, scale: 0.3}, commandCenterSymbol);
        this._gameSymbols.push({symName: symName, sym: commandCenterSymbol});
        return commandCenterSymbol;
    }

    private setPositionsAsOrientation(config:any, commandCenterSymbol:TractorBeamStickySymbol):void{
        commandCenterSymbol.scale.x = config.scale;
        commandCenterSymbol.scale.y = config.scale;
    }

    public resetCommandCenter(visibility:boolean){
        if(this._commandCenter){
            this._commandCenter.visible = visibility;
        }
        for(let i = 0; i< this._gameSymbols.length; i++){
            let tintColor = 0xFFFFFF;
            if(this._removedSymbols && this._removedSymbols.indexOf(this._gameSymbols[i].symName) > -1){
                tintColor = 0x555555;
            }
            this._gameSymbols[i].sym.symbolTint(tintColor);
        }
        this._removedSymbols = [];

        //TractorBeamGameModuleConfig.reelController.updateReelSetRelativeToCommandCenter(true);
    }

    public setInitialRemovedSymbols(removedSymbols:string[]){
        this._removedSymbols = removedSymbols;
    }

    public getGameSymbols():any{
        return this._gameSymbols;
    }

    public tintRemovedSymbol(symName:string):void{
        let toAnimateSymbol = this._gameSymbols.filter(function (item) {
            return item.symName === symName;
        });
        if(toAnimateSymbol.length > 0) {
            const winTl: TimelineLite = new TimelineLite({
                onComplete: () => {
                    winTl.pause();
                    winTl.kill();
                    toAnimateSymbol[0].sym.symbolTint(0x555555);
                }
            });

            if(this._removedSymbols.length < 9) {
                winTl.add(() => toAnimateSymbol[0].sym.playSymWin());
                winTl.add(new TweenLite(toAnimateSymbol[0].sym.scale, 0.1, {
                    x: this._config.scale,
                    y: this._config.scale
                }));
                winTl.add(new TweenLite(toAnimateSymbol[0].sym.scale, 0.1, {x: 0.7, y: 0.7}));
                winTl.add(new TweenLite(toAnimateSymbol[0].sym.scale, 0.1, {
                    x: this._config.scale,
                    y: this._config.scale
                }));
            }
        }
    }
}
